/**
 * RegistrationDiscoveryObservability (AJIP-16.02.005 · WS11)
 * ---------------------------------------------------------------------
 * 12 internal event kinds. Same emitter pattern as prior packages.
 */
const REGISTRATION_DISCOVERY_EVENTS = Object.freeze({
  JOURNEY_REGISTRATION_REQUESTED: 'JOURNEY_REGISTRATION_REQUESTED',
  JOURNEY_REGISTRATION_COMPLETED: 'JOURNEY_REGISTRATION_COMPLETED',
  JOURNEY_REGISTRATION_REJECTED: 'JOURNEY_REGISTRATION_REJECTED',
  JOURNEY_DEFINITION_VALIDATED: 'JOURNEY_DEFINITION_VALIDATED',
  JOURNEY_DEFINITION_INVALID: 'JOURNEY_DEFINITION_INVALID',
  JOURNEY_DISCOVERY_REQUESTED: 'JOURNEY_DISCOVERY_REQUESTED',
  JOURNEY_DISCOVERY_COMPLETED: 'JOURNEY_DISCOVERY_COMPLETED',
  JOURNEY_DISCOVERY_RETURNED_EMPTY: 'JOURNEY_DISCOVERY_RETURNED_EMPTY',
  JOURNEY_ELIGIBILITY_EVALUATED: 'JOURNEY_ELIGIBILITY_EVALUATED',
  JOURNEY_ELIGIBILITY_REJECTED: 'JOURNEY_ELIGIBILITY_REJECTED',
  DEPRECATED_JOURNEY_ENCOUNTERED: 'DEPRECATED_JOURNEY_ENCOUNTERED',
  REGISTRATION_CONFLICT_DETECTED: 'REGISTRATION_CONFLICT_DETECTED',
});

const ALL_REGISTRATION_DISCOVERY_EVENTS = Object.freeze(Object.values(REGISTRATION_DISCOVERY_EVENTS));

class RegistrationDiscoveryObservability {
  constructor() {
    this._handlers = new Map();
    for (const k of ALL_REGISTRATION_DISCOVERY_EVENTS) this._handlers.set(k, new Set());
    this._enabled = true;
  }
  on(kind, handler) {
    if (!ALL_REGISTRATION_DISCOVERY_EVENTS.includes(kind) || typeof handler !== 'function') return () => {};
    this._handlers.get(kind).add(handler);
    return () => this._handlers.get(kind).delete(handler);
  }
  emit(kind, payload) {
    if (!this._enabled || !ALL_REGISTRATION_DISCOVERY_EVENTS.includes(kind)) return 0;
    let count = 0;
    for (const h of this._handlers.get(kind)) {
      try { h(Object.freeze({ event: kind, at: Date.now(), payload })); count += 1; } catch (_e) { /* isolate */ }
    }
    return count;
  }
  listenerCount(kind) { return this._handlers.has(kind) ? this._handlers.get(kind).size : 0; }
}

export {
  REGISTRATION_DISCOVERY_EVENTS,
  ALL_REGISTRATION_DISCOVERY_EVENTS,
  RegistrationDiscoveryObservability,
};
